import { useMemo } from 'react';
import {
  DateFormatEnum,
  DateFormatPreference,
  TimeFormatEnum,
  TimeFormatPreference,
} from 'types/date';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';
import { useUserTenantPreference } from './preferences';

export const useDateTimeFormatPreference = () => {
  const {
    value: { dateFormat: userDateFormat = DateFormatEnum.DATE_FORMAT },
  } = useUserTenantPreference<DateFormatPreference>({
    key: PREFERENCE_KEYS.DATE_FORMAT,
  });
  const {
    value: { timeFormat: userTimeFormat = TimeFormatEnum.DETAILED_24_HOUR_TIME_FORMAT },
  } = useUserTenantPreference<TimeFormatPreference>({
    key: PREFERENCE_KEYS.TIME_FORMAT,
  });

  const userDateTimeFormat = useMemo(() => {
    const dateTimeFormat = `${userDateFormat} ${userTimeFormat} z`;
    return dateTimeFormat;
  }, [userDateFormat, userTimeFormat]);

  return { userDateTimeFormat, userDateFormat, userTimeFormat };
};
